// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2FrNZ","emails":"CreateEditClinics_emails__KlR-W","emailTagLabel":"CreateEditClinics_emailTagLabel__3ZN0F"};